module.exports = JBrowseExports["@mui/x-data-grid"];